<template>
  <div class="aviation">
    <div class="flights-table-wrapper">
      <AppDataTable tableName="flights" tableIcon="head-aviation-icon.svg" :dataProviderFunc="dataProvider" exportUrl="/aviation/export" :action="tableAction" />
    </div>
  </div>
</template>

<script>
import AppDataTable from '@/components/AppDataTable';

export default {
  name: 'Aviation',
  components: {
    AppDataTable
  },

  data() {
    return {
      tableAction: { name: 'View', url: '/aviation/:id/travelers' }
    };
  },

  methods: {
    async dataProvider(queryParams) {
      const url = '/aviation';
      this.$router.replace({ path: '/aviation', query: queryParams }).catch(() => {
        /* Avoid redundant navigation error */
      });

      const response = await this.$http.get(url, { params: queryParams });

      const data = { ...response.data };
      const processedData = { rowCount: data.rowCount, payload: data.payload, tableColumns: [] };
      for (let col of data.tableColumns) {
        if (col.showInTable) {
          processedData.tableColumns.push(col);
        }
      }

      for (let record of data.payload) {
        record.DEPART_DT = record.DEPART_TIME + ' ' + record.DEPART_DT;
        record.ARRIVE_DT = record.ARRIVE_TIME + ' ' + record.ARRIVE_DT;
        record.DEPART_PORT = `${record.DEPART_PORT} (${record.DEPART_PORT_CODE})`;
        record.ARRIVE_PORT = `${record.ARRIVE_PORT} (${record.ARRIVE_PORT_CODE})`;
      }

      return processedData;
    }
  }
};
</script>

<style lang="scss" scoped>
.flights-table-wrapper {
  margin: 0 auto;
  padding: 2rem 0;
  // height: calc(100% - 50px);
  width: 95vw;
}
</style>
